<template>
  <div>
    <!-- Filter Component -->
    <FilterList @update:params="getListData" />

    <BOverlay
      :show="loadingList"
      spinner-variant="primary"
      variant="light"
      blur="0"
      opacity=".5"
      rounded="sm"
    >
      <BTable
        id="table"
        :items="items"
        :fields="fields"
        show-empty
        responsive
        class="mt-1"
        style="min-height: 300px;"
      >
        <template #empty>
          <div
            v-if="search !== ''"
            class="text-center"
          >
            <div class="text-xl">
              Nomor Resi/Tiket tidak ditemukan
            </div>
            <div class="text-muted">
              Silahkan inputkan nomor resi/tiket lainnya
            </div>
          </div>
          <div
            v-else
            class="text-center"
          >
            <div class="text-xl">
              TIdak ada data untuk ditampilkan
            </div>
          </div>
        </template>
        <template #cell(cnote)="data">
          <a
            :href="`/data-order/detail-order/${data.item.order_id}`"
            target="_blank"
          >
            {{ data.value }}
          </a>
          <div class="text-muted">
            {{ data.item.ticket_no !== '' ? data.item.ticket_no : '-' }}
          </div>
        </template>
        <template #cell(created_at)="data">
          <div
            class="text-black"
            style="font-size: 13px;"
          >
            {{ DAY_MONTH_YEAR(data.value) }}
          </div>
          <div style="color: #828282; font-size: 12px;">
            {{ TIME(data.value) }} WIB
          </div>
          <div
            v-if="data.item.is_auto_claim"
            class="inline-block bg-[#E6F4FE] border border-[#D5EFFF] text-[#0090FF] rounded-full px-2 py-0.5 text-[11px] font-medium whitespace-nowrap mt-1"
          >
            Pengajuan Otomatis
          </div>
        </template>
        <template #cell(shipping)="data">
          <img
            :src="
              expedition.find(item => item.shipping_name === data.value)
                .image_path
            "
            alt="Komerce"
            style="width: 50px; margin: auto"
          >
        </template>
        <template #cell(claim_type)="data">
          <div class="d-flex flex-column">
            <span class="text-[#E31A1A]">
              {{ showTypeClaim(data.item.claim_type, 'title') }}
            </span>
            <span class="text-[12px] text-[#626262]">
              {{ showTypeClaim(data.item.claim_type, 'subtitle') }}
            </span>
          </div>
        </template>
        <template #cell(nominal)="data">
          <span class="text-black">{{ IDR(data.value) }}</span>
        </template>
        <template #cell(claim_proof)="data">
          <img
            src="https://storage.googleapis.com/komerce/assets/svg/eye.svg"
            alt="Komerce"
            style="margin: auto; cursor: pointer"
            @click="showProove(data.item)"
          >
        </template>
        <template #cell(order_id)="data">
          <span
            :class="data.item.ticket_no !== '' ? 'text-[#08a0f7] cursor-pointer' : ''"
            @click="data.item.ticket_no !== '' ? openNewTab(`/ticketing/detail/${data.item.ticket_id}`) : ''"
          >{{ data.item.ticket_no !== '' ? 'Lihat Tiket' : '-' }}</span>
        </template>
        <template #cell(status_claim)="data">
          <div
            v-b-tooltip.hover.top="data.value !== 0 ? `${getTooltips(data.item)}` : ''"
            class="justify-content-center rounded-pill border-[1px] w-[132px] flex"
            :class="getClassStatus(data.value)"
          >
            <div
              :class="data.value === 0 ? 'k-clock-1' : data.value === 1 ? 'k-tick-circle' : 'k-close-circle'"
              class="text-lg mr-[5px]"
            />
            <div class="text-[12px] align-self-center">
              {{ data.value === 0 ? 'Direview' : data.value === 1 ? 'Disetujui' : 'Ditolak' }}
            </div>
          </div>
        </template>
      </BTable>
    </BOverlay>

    <!-- Modal Proove -->
    <ModalApprove :proove-item="prooveItem" />

  </div>
</template>

<script>
import { IDR } from '@/libs/currency'
import { mapState } from 'vuex'
import { DAY_MONTH_YEAR, TIME } from '@/libs/formatDate'
import { openNewTab } from '@/libs/helpers'
import { coloumnTableList, listprooveItem } from './config'
import FilterList from './FilterList.vue'
import ModalApprove from './ModalApprove.vue'

export default {
  components: {
    FilterList,
    ModalApprove,
  },
  data() {
    return {
      IDR,
      DAY_MONTH_YEAR,
      TIME,
      openNewTab,
      loadingList: true,
      fields: coloumnTableList,
      items: [],
      limit: 50,
      offset: 0,
      isLastData: false,
      params: {},
      prooveItem: listprooveItem,
      search: '',
    }
  },
  computed: {
    ...mapState('filter', ['expedition']),
  },
  mounted() {
    window.onscroll = () => {
      if ((window.innerHeight + window.scrollY) >= document.getElementById('table').offsetHeight && !this.loadingList) {
        this.getNextData()
      }
    }
  },
  methods: {
    getListData(newParams) {
      this.offset = 0
      this.params = newParams
      this.search = newParams.search ? newParams.search : ''
      Object.assign(this.params, {
        limit: this.limit,
        offset: this.offset,
      })
      this.$http_new.get('/komship/api/v1/claims/list', { params: this.params })
        .then(response => {
          const { data } = response.data
          this.items = data
          this.offset = data.length
          this.loadingList = false
          if (this.items.length < this.limit) {
            this.isLastData = true
          } else {
            this.isLastData = false
          }
        })
        .catch(response => {
          this.loadingList = false
          this.$toast_error({ message: 'Gagal Mendapatkan List Tabel' })
        })
    },
    getNextData() {
      if (!this.isLastData) {
        this.loadingList = true
        this.$http_new.get('/komship/api/v1/claims/list', { params: this.params })
          .then(response => {
            const { data } = response.data
            this.items.push(...data)
            this.offset += data.length
            this.loadingList = false
            if (data.length < this.limit) {
              this.isLastData = true
            }
          })
          .catch(response => {
            this.loadingList = false
            this.$toast_error({ message: 'Gagal Mendapatkan List Tabel Berikutnya' })
          })
      }
    },
    showTypeClaim(data, part) {
      const claimTypeMap = {
        rusak: { title: 'Claim Delivered', subTitle: 'Paket Rusak' },
        tidak_diterima: {
          title: 'Claim Delivered',
          subTitle: 'Paket Tidak Diterima',
        },
        retur: { title: 'Claim', subTitle: 'Paket Retur' },
        hilang: { title: 'Claim', subTitle: 'Paket Hilang' },
        rts_rusak: { title: 'Claim RTS', subTitle: 'Paket Rusak' },
        rts_tidak_diterima: {
          title: 'Claim RTS',
          subTitle: 'Paket Tidak Diterima',
        },
        paksa_diterima: {
          title: 'Laporan',
          subTitle: 'Paket Diterima (Delivered)',
        },
        paksa_rts: { title: 'Laporan', subTitle: 'Paket Retur Diterima (RTS)' },
        diterima: { title: 'Laporan', subTitle: 'Paket Diterima' },
      }

      if (claimTypeMap[data]) {
        if (part === 'title') {
          return claimTypeMap[data].title
        }
        if (part === 'subtitle') {
          return claimTypeMap[data].subTitle
        }
      }

      return '-'
    },
    showProove(data) {
      this.prooveItem.cnote = data.cnote
      const filterImage = data.claim_proof.filter(item => item.type === 'image')
      this.prooveItem.images = filterImage
      const findPathVideo = data.claim_proof.find(item => item.type === 'video')
      this.prooveItem.video = findPathVideo ? findPathVideo.path : '-'
      this.prooveItem.type = data.claim_type
      this.$bvModal.show('modal-proove')
    },
    getTooltips(item) {
      const status = item.status_claim === 1 ? 'Disetujui' : 'Ditolak'
      const notes = item.notes ? item.notes : '-'

      return `Status diubah pada: ${DAY_MONTH_YEAR(item.updated_at)}.\n ${item.status_claim === 2 ? notes : ''}`
    },
    getClassStatus(value) {
      let result
      if (value === 0) {
        result = 'bg-[#E2E2E2] border-[#333333] text-[#333333]'
      } else if (value === 1) {
        result = 'bg-[#DCF3EB] border-[#34A770] text-[#34A770]'
      } else if (value === 2) {
        result = 'bg-[#FFEDED] border-[#E31A1A] text-[#E31A1A]'
      }
      return result
    },
  },
}
</script>
